module.exports = __webpack_public_path__ + "img/hadiah-1jt.4e4ebc66.png";